import type { Space } from "@/react/types/Space";
import { canManageSpace } from "@circle-react/helpers/spaceHelpers";
import { LeaveAndDeleteSpaceOptions } from "../../SpaceHeaderTitleDropdown/spaceOptions/LeaveAndDeleteSpaceOptions";
import { ManageSpaceOptions } from "../../SpaceHeaderTitleDropdown/spaceOptions/ManageSpaceOptions";
import { Separator } from "./Separator";

export const CourseSpaceOptions = ({
  space,
  isAdmin,
  setIsAddMemberOpen,
}: {
  space: Space;
  isAdmin: boolean;
  setIsAddMemberOpen: (isOpen: boolean) => void;
}) => {
  const canMemberManageSpace = canManageSpace(space);
  return (
    <>
      {canMemberManageSpace && (
        <>
          <ManageSpaceOptions
            space={space}
            onInviteMember={() => setIsAddMemberOpen(true)}
          />
          <Separator />
        </>
      )}
      <LeaveAndDeleteSpaceOptions space={space} isAdmin={isAdmin} />
    </>
  );
};
